// 只負責把音源設好，並在 resolve 時表示「可以播放了」。
window.textToSpeech = async function (text) {
    return new Promise(async (resolve, reject) => {
        const audioElement = document.getElementById("audioPlayer");
        const supportsMediaSource =
            "MediaSource" in window &&
            MediaSource.isTypeSupported("audio/mpeg");

        try {
            if (supportsMediaSource) {
                /* ---------- 串流模式 ---------- */
                const mediaSource = new MediaSource();
                audioElement.src = URL.createObjectURL(mediaSource);

                mediaSource.addEventListener("sourceopen", async () => {
                    try {
                        const sourceBuffer =
                            mediaSource.addSourceBuffer("audio/mpeg");

                        const response = await fetch(
                            "https://openai.rideasys.com/api/text-to-speech",
                            {
                                method: "POST",
                                headers: { "Content-Type": "application/json" },
                                body: JSON.stringify({ text }),
                            },
                        );

                        if (!response.ok || !response.body) {
                            resolve(false);
                            return;
                        }

                        const reader = response.body.getReader();
                        let queue = [];
                        let isAppending = false;

                        const appendNextChunk = () => {
                            if (
                                queue.length === 0 ||
                                isAppending ||
                                sourceBuffer.updating
                            ) {
                                return;
                            }
                            isAppending = true;
                            const chunk = queue.shift();
                            sourceBuffer.appendBuffer(chunk);
                        };

                        sourceBuffer.addEventListener("updateend", () => {
                            isAppending = false;
                            appendNextChunk();
                        });

                        // 首包要有資料才允許外層播放。
                        const firstChunk = await reader.read();
                        if (firstChunk.done || !firstChunk.value) {
                            resolve(false);
                            return;
                        }

                        queue.push(firstChunk.value.buffer);
                        appendNextChunk();
                        resolve(true);

                        while (true) {
                            const { done, value } = await reader.read();
                            if (done) {
                                if (mediaSource.readyState === "open") {
                                    if (sourceBuffer.updating) {
                                        sourceBuffer.addEventListener(
                                            "updateend",
                                            () => {
                                                if (
                                                    mediaSource.readyState ===
                                                    "open"
                                                ) {
                                                    mediaSource.endOfStream();
                                                }
                                            },
                                            { once: true },
                                        );
                                    } else {
                                        mediaSource.endOfStream();
                                    }
                                }
                                break;
                            }

                            if (value) {
                                queue.push(value.buffer);
                                appendNextChunk();
                            }
                        }
                    } catch (streamErr) {
                        reject(streamErr);
                    }
                });
            } else {
                /* ---------- Blob 模式 ---------- */
                const response = await fetch(
                    "https://openai.rideasys.com/api/text-to-speech",
                    {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ text }),
                    },
                );

                if (!response.ok) {
                    resolve(false);
                    return;
                }

                const blob = await response.blob();
                if (!blob || blob.size === 0) {
                    resolve(false);
                    return;
                }

                const blobUrl = URL.createObjectURL(blob);
                audioElement.src = blobUrl;
                resolve(true);
            }
        } catch (err) {
            reject(err);
        }
    });
};
